import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserData } from 'src/app/models/user.model';
import { NotUsingMyVehicleService } from 'src/app/services/not-using-my-vehicle/not-using-my-vehicle.service';
import { UserProvider } from 'src/app/services/providers/user-provider.ts/user-provider';
import { CoreService } from 'src/app/services/core/core.service';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { SqliteStorageService } from 'src/app/services/sqlite-storage/sqlite-storage.service';
import { resolveDriverData } from 'src/app/guards/vehicle-assigned/resolve-driver-data';

export const authGuard: CanActivateFn = async (route, state) => {
  const userProvider = inject(UserProvider);
  const notUsingMyVehicle = inject(NotUsingMyVehicleService);
  const coreService = inject(CoreService);
  const router = inject(Router);
  const dashboardService = inject(DashboardService);
  const sqliteStorageService = inject(SqliteStorageService);

  const currentUser: UserData | null = userProvider.getCurrentUserData;
  const isNotUsingMyVehicleRoute = state.url.startsWith('/not-using-my-vehicle');

  if (
    currentUser?.state.toLowerCase() === 'valid' &&
    coreService.isMobileApp &&
    currentUser.dataPrivacyAckRequired
  ) {
    userProvider.setIsLoggedIn(false);
    router.navigateByUrl('/privacy-policy');
    return false;
  }
  else if (currentUser?.state == 'Valid' && currentUser.accessToken.token) {
    userProvider.setIsLoggedIn(true);
    // Driver data must be known first so the declaration API is never called for a driver without a vehicle
    await resolveDriverData({ dashboardService, sqliteStorageService, userProvider }).catch(() => null);
    const declaration = await notUsingMyVehicle.getDeclarationFromSql();
    const shouldPrompt = await notUsingMyVehicle.shouldPromptDeclaration(declaration);

    if (shouldPrompt && !isNotUsingMyVehicleRoute && navigator.onLine) {
      router.navigateByUrl('/not-using-my-vehicle');
      return false;
    }

    if (!shouldPrompt && isNotUsingMyVehicleRoute) {
      router.navigateByUrl('/dashboard');
      return true;
    }

    return true;
  } else if (currentUser?.state == 'RegistrationRequired') {
    userProvider.setIsLoggedIn(false);
    router.navigateByUrl('/request-registration');
  } else {
    userProvider.setIsLoggedIn(false);
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  userProvider.setIsLoggedIn(true);
  return true;
};